const generatePassword = (length = 8) => {
  const numberChars = '0123456789';
  const upperChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const lowerChars = 'abcdefghijklmnopqrstuvwxyz';
  const symbolChars = '!@#$%^&*()_+=-';
  const allChars = numberChars + upperChars + lowerChars + symbolChars;

  const getRandomChar = (chars: string) => {
    return chars[Math.floor(Math.random() * chars.length)];
  };

  let password = [
    getRandomChar(numberChars),
    getRandomChar(upperChars),
    getRandomChar(lowerChars),
    getRandomChar(symbolChars),
  ]; //already generated 4 random password that contains at least one number, one char and one symbol

  for (let i = 4; i < length; i++) {
    password.push(getRandomChar(allChars)); //this will generate the other 4 charatcters and push into password array
  }

  // Shuffle the password array to ensure randomness
  password.sort(() => Math.random() - 0.5);

  return password.join('');
};

export { generatePassword };
